import router from '@/router';

export const getParamByName = name => {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  let results = regex.exec(location.search);
  return results == null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export function closeAllAudio() {
  const AudioEle = document.querySelectorAll("audio")
  return new Promise((resolve) => {
    if (!AudioEle.length) resolve(true) // 没有音频 直接返回
    if (AudioEle.length === 0) {
      return resolve(true)
    }
    AudioEle.forEach((item, index) => {
      item.pause()
      if (AudioEle.length - 1 === index) {
        setTimeout(() => {
          resolve(true)
        }, 200)
      }
    })
  })
}

export function arraysHaveSameIds(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false; // 数组长度不同，直接返回 false
  }

  const idSet1 = new Set(arr1);
  const idSet2 = new Set(arr2);

  for (const id of idSet1) {
    if (!idSet2.has(id)) {
      return false; // arr1 中的某个 id 在 arr2 中不存在
    }
  }

  return true; // 所有 id 都匹配
}


export function goLogin(linkUrl = location.href) {
  if (location.href.indexOf('/login') > -1) return; // 当前就在登录页面
  const routerName = linkUrl.indexOf('teacher') !== -1 ? 'teacherLogin' : 'login';
  const route = router.resolve({
    name: routerName,
    query: {
      redirect: encodeURIComponent(linkUrl)
    }
  })
  window.location.replace(route.href);
}

/**
 * 压缩图片文件
 * @param {File|Blob} file 输入文件，类型需为图片类型
 * @param {Object} options 可选配置 { maxWidth=1600, maxHeight=1600, quality=0.8, mimeType }
 *  - maxWidth/maxHeight: 限制长边尺寸，按比例缩放
 *  - quality: 0-1，仅对有损格式生效（image/jpeg、image/webp）
 *  - mimeType: 输出类型，默认根据原图类型选择（jpg/png/webp），优先使用 jpeg 以明显减小体积
 * @returns {Promise<File>} 压缩后的 File（文件名追加 .compressed）
 */
export async function compressImage(file, options = {}) {
  const { maxWidth = 1600, maxHeight = 1600, quality = 0.8, mimeType } = options;

  if (!(file instanceof Blob)) return Promise.reject(new Error('输入必须是图片文件'));
  const inputType = (file.type || 'image/jpeg').toLowerCase();
  const outputType = (mimeType || (inputType.includes('png') ? 'image/jpeg' : inputType));

  const dataURL = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const img = await new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = dataURL;
  });

  const { width, height } = img;
  let targetWidth = width;
  let targetHeight = height;

  // 按最大宽高等比缩放
  const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
  targetWidth = Math.round(width * ratio);
  targetHeight = Math.round(height * ratio);

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  const blob = await new Promise((resolve) => {
    // 对 jpeg/webp 使用质量参数，其他类型忽略
    const q = /jpeg|jpg|webp/.test(outputType) ? quality : 1;
    canvas.toBlob((b) => resolve(b), outputType, q);
  });

  // 回退：toBlob 可能在极端情况下返回 null
  const finalBlob = blob || await (async () => {
    const fallbackDataUrl = canvas.toDataURL(outputType);
    const byteString = atob(fallbackDataUrl.split(',')[1]);
    const mime = fallbackDataUrl.split(',')[0].match(/:(.*?);/)[1];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
    return new Blob([ab], { type: mime });
  })();

  // 生成 File 以便与原上传接口兼容
  const compressedFile = new File([finalBlob], appendFileSuffix(getFileName(file), '.compressed', outputType), { type: finalBlob.type, lastModified: Date.now() });
  return compressedFile;
}

function getFileName(file) {
  return (file && file.name) ? file.name : 'image.jpg';
}

function appendFileSuffix(name, suffix, mime) {
  const dot = name.lastIndexOf('.');
  const base = dot > -1 ? name.slice(0, dot) : name;
  const extFromMime = mime && mime.split('/')[1] ? mime.split('/')[1].replace('jpeg', 'jpg') : 'jpg';
  return `${base}${suffix}.${extFromMime}`;
}

/**
 * 去除对象中值为 undefined 或 null 或 空字符串 的字段
 * @param {ParamsType} params 待处理的对象
 * @returns {ParamsType} 处理后的对象
 */
export default function parseParams(params) {
  let res = {};
  if (params) {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        res = {
          ...res,
          [key]: params[key],
        };
      }
    });
  }
  return res;
}

